<template lang="pug">
  .exchange-goods-panel-container
    .panel-header
      img.title(
        src="https://m.hellobike.com/file-1756088284987-768687282.png"
        alt=""
      )
      .more-btn(@click="handleMoreClick")
        .text 更多兑换
        img.arrow(
          src="https://m.hellobike.com/resource/gallery/3/YsSIswNW_title-info.png"
          alt=""
        )
    .panel-content
      .goods-select-list
        .goods-select-item(
          v-for="(item, index) in exchangeGoodsList"
          :class="{ 'goods-select-item-selected': index === selectedGoodsIdx }"
          @click="handleGoodsSelectClick(index)"
        )
          SafeImage(class="goods-logo" :src="item.image" pureBgColor="#f0f3f5" alt="" )
      .exchange-progress
        .exchange-progress-text 需{{ selectedGoodsInfo.amount }}币
        .exchange-progress-bar(:style="{ width: `${progressPercent}%` }")
          .exchange-progress-bar-text 需{{ selectedGoodsInfo.amount }}币
      .goods-exchange-tips
        .exchange-and-pay(
          v-if="isShowPay"
          @click="handleExchangeAndPay"
        ) 使用{{selectedGoodsInfo.pointsDeduction}}币+{{selectedGoodsInfo.salePriceAfterDeduction}}元
        HighlightText(
          v-else
          :text="exchangeDesc"
          :normalStyle="{ color: '#242729', fontSize: '0.14rem' }"
          :highlightStyle="{ color: '#000', fontSize: '0.14rem', fontWeight: 600 }"
        )
        .tips-btn(:class="{'is-multi': isShowPay}" @click="handleBtnClick") {{ btnText }}

</template>

<script>
import { SafeImage, HighlightText } from '@hb/platformui-h5';
import { Storage } from '@/utils/storage';
import SPM from '../common/spm';
import { STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID } from '../consts';

export default {
  name: 'ExchangeGoods',
  components: {
    SafeImage,
    HighlightText,
  },
  props: {
    // 兑换商品列表
    exchangeGoodsList: {
      type: Array,
      default: () => [],
    },
    // 奖励金数量
    points: {
      type: Number,
      default: 0,
    },
    // 当前选择的商品ID
    chooseSkuId: {
      type: String,
      default: '',
    },
    guideDesc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 当前选择的商品索引
      selectedGoodsIdx: 0,
      // 当前选择的商品信息
      selectedGoodsInfo: {},
      // 埋点去重标记
      hasExposedBtnText: '',
      hasExposedPay: false,
    };
  },
  computed: {
    // 进度条百分比
    progressPercent() {
      const { amount } = this.selectedGoodsInfo || {};
      if (this.points < amount) {
        return Math.floor((this.points / amount) * 100);
      }
      return 100;
    },
    // 兑换按钮文案
    btnText() {
      const { amount } = this.selectedGoodsInfo || {};
      return this.points >= amount ? '去兑换' : '赚奖励金';
    },
    isShowPay() {
      const {
        amount,
        salePriceAfterDeduction,
      } = this.selectedGoodsInfo;
      return this.points < amount && salePriceAfterDeduction > 0;
    },
    // 兑换描述
    exchangeDesc() {
      const { amount } = this.selectedGoodsInfo || {};
      if (this.points < amount) {
        const spreadNum = amount - this.points;
        const guideText = this.guideDesc || '点外卖快速攒币';
        return `差${spreadNum || ''}币，${guideText}`;
      }
      return '已攒够，快去兑换吧';
    },

  },
  watch: {
    btnText: {
      handler(val) {
        if (this.hasExposedBtnText === val) return;
        this.hasExposedBtnText = val;
        const { skuId, title } = this.selectedGoodsInfo || {};
        if (val === '去兑换') {
          SPM.moduleExpose({
            moduleId: 'new_comexchange_duihuan',
            contentId: 'new_comexchange_duihuan',
            businessInfo: { skuId, goodsName: title },
          });
        } else {
          SPM.moduleExpose({
            moduleId: 'new_comexchange_go',
            contentId: 'new_comexchange_go',
            businessInfo: { spuId: skuId, goodsName: title },
          });
        }
      },
      immediate: true,
    },
    isShowPay: {
      handler(val) {
        if (!val || this.hasExposedPay) return;
        this.hasExposedPay = true;
        const {
          skuId, title, pointsDeduction, salePriceAfterDeduction,
        } = this.selectedGoodsInfo || {};
        SPM.moduleExpose({
          moduleId: 'platform_addCashBuy',
          contentId: 'platform_addCashBuy',
          businessInfo: {
            skuId,
            goodsName: title,
            exchangebonus: pointsDeduction,
            exchangeNeedCash: salePriceAfterDeduction,
          },
        });
      },
      immediate: true,
    },
    // 监听商品列表变化，刷新当前选中商品信息
    exchangeGoodsList() {
      this.selectedGoodsInfo = this.exchangeGoodsList[this.selectedGoodsIdx] || {};
    },
    // 监听当前选择的商品ID变化
    chooseSkuId: {
      handler(newVal) {
        const idx = this.exchangeGoodsList.findIndex(
          (item) => item.skuId === newVal,
        );
        this.selectedGoodsIdx = idx !== -1 ? idx : 0;
        this.selectedGoodsInfo = this.exchangeGoodsList[this.selectedGoodsIdx] || {};
      },
      immediate: true,
    },
    selectedGoodsInfo: {
      handler(newVal) {
        this.$emit('setCurrentExchangeInfo', newVal);
      },
      immediate: true,
    },
  },
  mounted() {
    // 商品模块曝光
    this.handleGoodsModuleExpose();
  },
  methods: {
    // 商品选择点击
    handleGoodsSelectClick(idx) {
      this.selectedGoodsIdx = idx;
      this.selectedGoodsInfo = this.exchangeGoodsList[idx] || {};
      // 缓存点击的商品信息
      const {
        skuId,
        title,
        pointsDeduction,
        salePriceAfterDeduction,
        cost,
      } = this.selectedGoodsInfo || {};
      try {
        Storage.setItem(STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID, skuId);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('handleGoodsSelectClick error', error);
      }

      SPM.clickButton({
        buttonName: 'new_comexchange_sku',
        businessInfo: {
          spuId: skuId || '',
          goodsName: title || '',
          exchangeNeedCash: salePriceAfterDeduction,
          exchangebonus: pointsDeduction,
          isSupportCash: !!(salePriceAfterDeduction && pointsDeduction),
          exchangeTotalBonus: cost,
        },
      });
    },
    // 兑换商品按钮点击
    handleBtnClick() {
      const { amount, skuId, title } = this.selectedGoodsInfo || {};
      if (this.points >= amount) {
        // 奖励金足够 => 去兑换
        this.$emit('exchange', this.selectedGoodsInfo);
        SPM.clickButton({
          buttonName: 'new_comexchange_duihuan',
          businessInfo: { skuId, goodsName: title },
        });
      } else {
        // 奖励金不足 => 去赚奖励金
        this.$emit('earnPoints');
        SPM.clickButton({
          buttonName: 'new_comexchange_go',
          businessInfo: { spuId: skuId, goodsName: title },
        });
      }
    },
    // 更多兑换点击
    handleMoreClick() {
      this.$emit('moreClick');
      SPM.clickButton({
        buttonName: 'new_comexchange_more',
        businessInfo: {},
      });
    },
    handleExchangeAndPay() {
      const {
        title,
        skuId,
        pointsDeduction,
        salePriceAfterDeduction,
      } = this.selectedGoodsInfo || {};
      this.$emit('exchange', this.selectedGoodsInfo);
      SPM.clickButton({
        buttonName: 'platform_addCashBuy',
        businessInfo: {
          goodsName: title,
          skuId,
          exchangebonus: pointsDeduction,
          exchangeNeedCash: salePriceAfterDeduction,
        },
      });
    },
    // 商品模块曝光
    handleGoodsModuleExpose() {
      const { skuId = '' } = this.exchangeGoodsList[0] || {};
      // 商品兑换模块曝光
      SPM.moduleExpose({
        moduleId: 'new_comexchange',
        contentId: 'new_comexchange',
        businessInfo: {
          spuId: this.chooseSkuId || skuId,
        },
      });

      // 商品列表曝光
      this.exchangeGoodsList.forEach((item) => {
        SPM.moduleExpose({
          moduleId: 'new_comexchange_sku',
          contentId: 'new_comexchange_sku',
          businessInfo: {
            spuId: item.skuId,
            goodsName: item.title,
            exchangeNeedCash: item.salePriceAfterDeduction,
            exchangebonus: item.pointsDeduction,
            isSupportCash: !!(item.salePriceAfterDeduction && item.pointsDeduction),
            exchangeTotalBonus: item.cost,
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-goods-panel-container {
  background-image:
    linear-gradient(
      174.11deg,
      #ddf1ff 4.45%,
      #fff 29.35%,
      #fff 95.32%
    );
  box-sizing: border-box;
  border: 0.01rem solid #fff;
  border-radius: 0.16rem;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.12rem 0.11rem 0 0.13rem;
    height: 0.24rem;

    .title {
      width: auto;
      height: 0.15rem;
      vertical-align: bottom;
    }

    .more-btn {
      display: flex;
      align-items: center;

      .text {
        font-size: 0.13rem;
        line-height: normal;
        color: #5a6066;
      }

      .arrow {
        width: 0.12rem;
        height: 0.12rem;
        margin-left: 0.02rem;
      }
    }
  }

  .panel-content {
    margin-top: 0.12rem;
  }

  .goods-select-list {
    display: flex;
    align-items: flex-end;
    flex-wrap: nowrap;
    padding: 0 0.1rem;
    height: 0.55rem;

    .goods-select-item {
      margin-right: 0.05rem;
      width: 0.76rem;
      height: 0.48rem;
      transition: all 0.3s ease-in-out;

      &:last-child {
        margin-right: 0;
      }

      .goods-logo {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
        border-radius: 0.08rem;
      }
    }

    .goods-select-item-selected {
      position: relative;
      width: 0.95rem;
      height: 0.54rem;
      padding: 0 0.05rem;

      &::before {
        content: '';
        position: absolute;
        top: -0.05rem;
        left: 50%;
        transform: translateX(-50%);
        width: 0.96rem;
        height: 0.69rem;
        background-image: url('https://m.hellobike.com/6ff5d4b7_Rectangle%20346242285.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        opacity: 0;
        animation: show 0.3s ease-in-out 0.3s both;
      }

      @keyframes show {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  }

  .exchange-progress {
    overflow: hidden;
    position: relative;
    margin: 0.14rem auto 0;
    width: 3.36rem;
    height: 0.12rem;
    background-color: #ffebeb;
    border-radius: 0.12rem;

    .exchange-progress-text {
      position: absolute;
      top: 0;
      left: 1.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1rem;
      height: 100%;
      font-size: 0.1rem;
      line-height: normal;
      color: #db9a9a;
    }

    .exchange-progress-bar {
      position: relative;
      overflow: hidden;
      width: 0;
      height: 0.12rem;
      background-image: linear-gradient(270deg, #ff3654 0.6%, #ff8798 100%);
      border-radius: 0.12rem 0 0 0.12rem;
      transition: width 0.5s ease;
    }

    .exchange-progress-bar-text {
      position: absolute;
      top: 0;
      left: 1.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1rem;
      height: 100%;
      font-size: 0.1rem;
      line-height: normal;
      color: #fff;
    }
  }

  .goods-exchange-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.08rem 0.11rem 0.09rem 0.18rem;

    .exchange-text {
      font-family: PingFang SC, sans-serif;
      font-weight: 400;
      font-style: regular;
      font-size: 0.14rem;
      letter-spacing: 0;
      color: #242729;
      line-height: 0.2rem;
    }

    .exchange-and-pay {
      box-sizing: border-box;
      background: linear-gradient(291.9deg, #ffda9c 29.79%, #ffefd3 89.13%);
      height: 0.28rem;
      border: 1px solid #ffe4b6;
      padding: 0 0.18rem;
      border-radius: 0.39rem;
      font-family: PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.14rem;
      color: #623f00;
      margin-left: auto;
      display: flex;
      align-items: center;
    }

    .tips-btn {
      flex-shrink: 0;
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.76rem;
      height: 0.28rem;
      background-image:
        linear-gradient(
          97.17deg,
          #ff598e 7.46%,
          #f52845 49.23%,
          #ff3c69 70.12%,
          #ff7084 91%
        );
      border-radius: 0.4rem;
      font-size: 0.14rem;
      line-height: normal;
      color: #fff;

      &.is-multi {
        margin-left: 0.08rem;
      }
    }
  }
}
</style>
